/* Pano — comparateur de kits. Vanilla, sans dépendance.
   Parcours : bouton « Comparer » sur les fiches -> barre collante -> page /comparateur. */
(function () {
  'use strict';

  var KEY = 'pano-compare';
  var trayEl = document.getElementById('pano-compare-tray');
  var MAX = trayEl && parseInt(trayEl.dataset.max, 10) ? parseInt(trayEl.dataset.max, 10) : 3;

  /* ---------- stockage ---------- */
  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* quota */ }
  }

  function toggle(data) {
    if (!data.id) return;
    var list = read();
    var idx = list.map(function (p) { return p.id; }).indexOf(data.id);
    if (idx > -1) {
      list.splice(idx, 1);
    } else {
      if (list.length >= MAX) { flashLimit(); return; }
      list.push(data);
    }
    write(list);
    syncAll();
  }
  function removeId(id) { write(read().filter(function (p) { return p.id !== id; })); syncAll(); }
  function clearAll() { write([]); syncAll(); }

  /* ---------- boutons sur fiches / page produit ---------- */
  function syncButtons() {
    var ids = read().map(function (p) { return p.id; });
    document.querySelectorAll('.js-pano-compare-btn').forEach(function (btn) {
      var active = ids.indexOf(btn.dataset.productId) > -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      var label = btn.querySelector('.js-pano-compare-label');
      if (label) label.textContent = active ? 'Ajouté au comparateur' : 'Comparer';
    });
  }

  /* ---------- barre collante ---------- */
  function syncTray() {
    if (!trayEl) return;
    var list = read();
    if (!list.length) { trayEl.hidden = true; return; }
    trayEl.hidden = false;

    trayEl.querySelector('.js-pano-ct-items').innerHTML = list.map(function (p) {
      return '<div class="pano-ct__item">' +
        (p.image ? '<img class="pano-ct__thumb" src="' + p.image + '" alt="" loading="lazy">' : '') +
        '<span class="pano-ct__name">' + esc(p.title || '') + '</span>' +
        '<button type="button" class="pano-ct__remove js-pano-ct-remove" data-product-id="' +
        esc(p.id) + '" aria-label="Retirer ' + esc(p.title || '') + '">&times;</button>' +
        '</div>';
    }).join('');

    var cta = trayEl.querySelector('.js-pano-ct-go');
    cta.href = '/pages/comparateur?kits=' +
      list.map(function (p) { return encodeURIComponent(p.handle); }).join(',');
    cta.textContent = 'Comparer (' + list.length + ')';
    var ready = list.length >= 2;
    cta.classList.toggle('is-disabled', !ready);
    cta.setAttribute('aria-disabled', ready ? 'false' : 'true');
  }

  function flashLimit() {
    if (!trayEl) return;
    var msg = trayEl.querySelector('.js-pano-ct-msg');
    if (!msg) return;
    msg.textContent = 'Maximum ' + MAX + ' kits dans le comparateur.';
    msg.classList.add('is-shown');
    clearTimeout(flashLimit._t);
    flashLimit._t = setTimeout(function () { msg.classList.remove('is-shown'); }, 2600);
  }

  function syncAll() { syncButtons(); syncTray(); }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- page /comparateur ---------- */
  function renderComparateur() {
    var host = document.getElementById('pano-comparateur-table');
    if (!host) return;
    var empty = document.getElementById('pano-comparateur-empty');

    var params = new URLSearchParams(window.location.search);
    var handles = (params.get('kits') || '').split(',')
      .map(function (h) { return decodeURIComponent(h.trim()); }).filter(Boolean);
    if (!handles.length) handles = read().map(function (p) { return p.handle; }).filter(Boolean);
    handles = handles.slice(0, MAX);

    if (handles.length < 2) {
      host.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    host.innerHTML = '<div class="pano-cmp__loading">Chargement du comparatif…</div>';

    Promise.all(handles.map(function (h) {
      return fetch('/products/' + h)
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (!html) return null;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var tpl = doc.querySelector('.cc-compare template');
          if (!tpl) return null;
          var cols = {};
          tpl.content.querySelectorAll('[data-compare-key]').forEach(function (col) {
            cols[col.dataset.compareKey] = col;
          });
          return { handle: h, cols: cols };
        })
        .catch(function () { return null; });
    })).then(function (results) {
      results = results.filter(Boolean);
      if (results.length < 2) {
        host.innerHTML = '<p class="pano-cmp__error">Comparatif momentanément indisponible. Réessaie dans un instant.</p>';
        return;
      }
      buildTable(host, results);
    });
  }

  function buildTable(host, results) {
    var n = results.length;
    // lignes de specs = les metafields configurés (puissance, onduleur, garantie…),
    // dans l'ordre du 1er produit. Image/titre/prix vont dans l'en-tête.
    var specKeys = Object.keys(results[0].cols).filter(function (k) {
      return k.indexOf('compare-metafield') === 0;
    });

    var cells = [];
    // coin haut-gauche vide
    cells.push('<div class="pano-cmp__corner"></div>');
    // en-tête : une carte produit par colonne
    results.forEach(function (res) {
      var img = res.cols['compare-image'];
      var title = res.cols['compare-title'];
      var price = res.cols['compare-price'];
      cells.push('<div class="pano-cmp__product">' +
        '<div class="pano-cmp__product-img">' + (img ? img.innerHTML : '') + '</div>' +
        '<div class="pano-cmp__product-title">' + (title ? title.innerHTML : '') + '</div>' +
        '<div class="pano-cmp__product-price">' + (price ? price.innerHTML : '') + '</div>' +
        '<a class="pano-cmp__view" href="/products/' + esc(res.handle) + '">Voir le kit</a>' +
        '</div>');
    });
    // lignes de specs
    specKeys.forEach(function (key) {
      var label = '';
      results.forEach(function (res) {
        if (label) return;
        var col = res.cols[key];
        var l = col && col.querySelector('.compare-label');
        if (l) label = l.textContent.trim();
      });
      cells.push('<div class="pano-cmp__label">' + esc(label) + '</div>');
      results.forEach(function (res) {
        var col = res.cols[key];
        var html = '<span class="pano-cmp__na">—</span>';
        if (col) {
          var val = col.querySelector('.compare-value');
          html = val ? val.innerHTML : col.innerHTML;
        }
        cells.push('<div class="pano-cmp__cell">' + html + '</div>');
      });
    });

    host.style.setProperty('--pano-cmp-cols', n);
    host.className = 'pano-cmp';
    host.innerHTML = cells.join('');
  }

  /* ---------- événements ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.js-pano-compare-btn');
    if (btn) {
      e.preventDefault();
      toggle({
        id: btn.dataset.productId,
        handle: btn.dataset.productHandle,
        url: btn.dataset.productUrl,
        title: btn.dataset.productTitle,
        image: btn.dataset.productImage
      });
      return;
    }
    var rm = e.target.closest('.js-pano-ct-remove');
    if (rm) { removeId(rm.dataset.productId); return; }
    if (e.target.closest('.js-pano-ct-clear')) { clearAll(); return; }
    var go = e.target.closest('.js-pano-ct-go');
    if (go && go.classList.contains('is-disabled')) { e.preventDefault(); }
  });

  // synchro entre onglets
  window.addEventListener('storage', function (e) { if (e.key === KEY) syncAll(); });

  function init() { syncAll(); renderComparateur(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
